/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const AuditReportsPermissions = {
    Reports_Manage: "audit-reports:reports:manage",
    AodRules_Manage: "audit-reports:aod-rules:manage",
    AodRules_View: "audit-reports:aod-rules:view"
} as const;

export type PermissionsIdsDtoAuditReportsPermissionsEnumKey = (typeof AuditReportsPermissions)[keyof typeof AuditReportsPermissions];

export type PermissionsIdsDto = {
    /**
     * @description Available permissions for the audit-reports provider
     * @type string
    */
    AuditReportsPermissions: PermissionsIdsDtoAuditReportsPermissionsEnumKey;
};